export default {
  overFooterTitle: 'La plataforma digital para aprender en la vida real',
  itsKimple: 'Es posible, es Kimple.',
  disclaimer: '{year} - Kimple - Todos los derechos reservados',
  begin: 'Contacta con nosotros',
  awards: 'Premios'
}

export const en = {
  overFooterTitle: 'The digital platform to learn in real life',
  itsKimple: 'It\'s possible, it\'s Kimple',
  disclaimer: '{year} - Kimple - All rights reserved',
  begin: 'Contact',
  awards: 'Awards'
}

export const ca = {
  overFooterTitle: 'La plataforma digital per aprendre a la vida real',
  itsKimple: 'És possible, és Kimple.',
  disclaimer: '{year} - Kimple - Tots els drets reservats',
  begin: 'Posa\'t en contacte amb nosaltres',
  awards: 'Premis'
}
